import React from "react";

import { Divider } from "@olist/design-system";
import { Container } from "@olist/templates";

import { HeaderWrapper, NavigationWrapper, WarningContainer } from "./styles";
import { Navigation } from "../navigation";
import { Logo } from "components/global/logo";
import { WikiJsSearch } from "components/global/wikijs-search";

const shouldShowMaintenanceWarning =
  process.env.REACT_APP_MAINTENANCE_WARNING === "true";

export function Header() {
  const isKnowledgebase =
    window.location.pathname.startsWith("/kb") ||
    window.location.pathname === "/";
  const isNotSupport = !window.location.pathname.startsWith("/support");

  const shouldRenderSearch = isKnowledgebase || isNotSupport;

  return (
    <header>
      {shouldShowMaintenanceWarning && (
        <WarningContainer>
          <Container>
            Estamos realizando uma manutenção em nossos serviços, é possível que
            alguns serviços fiquem intermitentes.
            <br />
            Horário previsto para normalização: <b>18:00 (UTC-3)</b>
          </Container>
        </WarningContainer>
      )}
      <HeaderWrapper id="help-center-header">
        <Container>
          <Logo />
          {shouldRenderSearch && <WikiJsSearch />}
        </Container>
      </HeaderWrapper>
      <NavigationWrapper>
        <Container>
          <Navigation />
        </Container>
        <Divider />
      </NavigationWrapper>
    </header>
  );
}
